import { render, staticRenderFns } from "./ObrigadoSegundaAlmaGemea.vue?vue&type=template&id=4ce5875e"
import script from "./ObrigadoSegundaAlmaGemea.vue?vue&type=script&lang=js"
export * from "./ObrigadoSegundaAlmaGemea.vue?vue&type=script&lang=js"
import style0 from "./ObrigadoSegundaAlmaGemea.vue?vue&type=style&index=0&id=4ce5875e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports